import { InputErrorMessageVariantType } from '../../../../../components/internal/inputErrorMessage/types/inputErrorMessageVariantType';
import { InputHelpMessageVariantType } from '../../../../../components/internal/inputHelpMessage/types/inputHelpMessageVariantType';
import { TextCountVariantType } from '../../../../../components/textCountV2/types/textCountVariantType';
import { InputBaseVariantType, InputDecorationVariantType, InputLabelVariantType, } from '../variants';
const commonStateStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    ...STATE_TOKENS,
    container: {
        display: 'flex',
        flex_direction: 'column',
        flex: '1 1 0',
        min_width: '0',
        gap: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS.container,
    },
    inputContainer: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_150,
        padding: FOUNDATIONS.spacing_200,
        border_width: FOUNDATIONS.border_50,
        border_style: 'solid',
        border_color: FOUNDATIONS.color_neutral_border_150,
        border_radius: FOUNDATIONS.radius_comp_forms_input_radiussize,
        background_color: FOUNDATIONS.color_comp_forms_input_bg,
        min_height: FOUNDATIONS.size_450,
        ...STATE_TOKENS.inputContainer,
    },
    inputBase: { variant: InputBaseVariantType.REGULAR, ...STATE_TOKENS.inputBase },
    label: { variant: InputLabelVariantType.REGULAR, ...STATE_TOKENS.label },
    leftDecoration: { variant: InputDecorationVariantType.REGULAR, ...STATE_TOKENS.leftDecoration },
    rightDecoration: { variant: InputDecorationVariantType.REGULAR, ...STATE_TOKENS.rightDecoration },
    clearIcon: { variant: InputDecorationVariantType.REGULAR, ...STATE_TOKENS.clearIcon },
    errorMessage: { variant: InputErrorMessageVariantType.REGULAR, ...STATE_TOKENS.errorMessage },
    helpMessage: { variant: InputHelpMessageVariantType.REGULAR, ...STATE_TOKENS.helpMessage },
    textCount: { variant: TextCountVariantType.DEFAULT, ...STATE_TOKENS.textCount },
    messageWithTextCountContainer: {
        display: 'flex',
        justify_content: 'space-between',
        ...STATE_TOKENS.messageWithTextCountContainer,
    },
    textCountContainer: {
        display: 'flex',
        justify_content: 'flex-end',
        flex: 1,
        ...STATE_TOKENS.textCountContainer,
    },
});
export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    ["FOCUSED" /* InputDateStateType.FOCUSED */]: {
        ...commonStateStyles(FOUNDATIONS, {
            ...STATE_TOKENS["FOCUSED" /* InputDateStateType.FOCUSED */],
            inputContainer: {
                border_color: 'transparent',
                outline_offset: 'unset',
                box_shadow: 'none',
                outline: `${FOUNDATIONS.color_comp_forms_input_active_border} solid ${FOUNDATIONS.border_100}`,
                outline_width: FOUNDATIONS.border_100,
                outline_style: 'solid',
                outline_color: FOUNDATIONS.color_comp_forms_input_active_border,
                ...STATE_TOKENS["FOCUSED" /* InputDateStateType.FOCUSED */]?.inputContainer,
            },
        }),
    },
    ["FILLED" /* InputDateStateType.FILLED */]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS["FILLED" /* InputDateStateType.FILLED */] }),
    },
    ["EMPTY" /* InputDateStateType.EMPTY */]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS["EMPTY" /* InputDateStateType.EMPTY */] }),
    },
    ["ERROR_EMPTY" /* InputDateStateType.ERROR_EMPTY */]: {
        ...commonStateStyles(FOUNDATIONS, {
            ...STATE_TOKENS["ERROR_EMPTY" /* InputDateStateType.ERROR_EMPTY */],
            inputContainer: {
                border_color: 'transparent',
                outline: `${FOUNDATIONS.color_feedback_error_border_50} solid ${FOUNDATIONS.border_100}`,
                outline_offset: 'unset',
                box_shadow: 'none',
                background_color: FOUNDATIONS.color_comp_forms_input_error_empty_bg,
                ...STATE_TOKENS["ERROR_EMPTY" /* InputDateStateType.ERROR_EMPTY */]?.inputContainer,
            },
        }),
    },
    ["ERROR_FILLED" /* InputDateStateType.ERROR_FILLED */]: {
        ...commonStateStyles(FOUNDATIONS, {
            ...STATE_TOKENS["ERROR_FILLED" /* InputDateStateType.ERROR_FILLED */],
            inputContainer: {
                border_color: 'transparent',
                outline: `${FOUNDATIONS.color_feedback_error_border_50} solid ${FOUNDATIONS.border_100}`,
                outline_offset: 'unset',
                box_shadow: 'none',
                background_color: FOUNDATIONS.color_comp_forms_input_error_filled_bg,
                ...STATE_TOKENS["ERROR_FILLED" /* InputDateStateType.ERROR_FILLED */]?.inputContainer,
            },
        }),
    },
    ["DISABLED_EMPTY" /* InputDateStateType.DISABLED_EMPTY */]: {
        ...commonStateStyles(FOUNDATIONS, {
            ...STATE_TOKENS["DISABLED_EMPTY" /* InputDateStateType.DISABLED_EMPTY */],
            inputContainer: {
                background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                border_width: FOUNDATIONS.border_50,
                border_color: FOUNDATIONS.color_accent_disabled_border_100,
                ...STATE_TOKENS["DISABLED_EMPTY" /* InputDateStateType.DISABLED_EMPTY */]?.inputContainer,
            },
        }),
    },
    ["DISABLED_FILLED" /* InputDateStateType.DISABLED_FILLED */]: {
        ...commonStateStyles(FOUNDATIONS, {
            ...STATE_TOKENS["DISABLED_FILLED" /* InputDateStateType.DISABLED_FILLED */],
            inputContainer: {
                background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                border_width: FOUNDATIONS.border_50,
                border_color: FOUNDATIONS.color_accent_disabled_border_100,
                ...STATE_TOKENS["DISABLED_FILLED" /* InputDateStateType.DISABLED_FILLED */]?.inputContainer,
            },
        }),
    },
});
//# sourceMappingURL=commonStyles.js.map